<template>
    <div class="banner-wrapper">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div v-for="item in banner" :key="item.itemId" class="swiper-slide">
                    <a :href="filterLink(item)" v-if="isHyperlinks(filterLink(item))">
                        <img :src="item.imgUrl || ''" @load="imgLoad" @error="imgError" alt="">
                        <div class="banner-title">
                            <span>{{item.itemTitle}}</span>
                        </div>
                    </a>
                    <router-link :to="{path: filterLink(item)}" v-else>
                        <img :src="item.imgUrl || ''" @load="imgLoad" @error="imgError" alt="">
                        <div class="banner-title">
                            <span>{{item.itemTitle}}</span>
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="swiper-pagination" slot="pagination"></div>
        </div>
    </div>
</template>

<script>

import Swiper from 'swiper/js/swiper.min.js'
import 'swiper/css/swiper.css'

import Filters from '@/utils/filters'

import { mapState } from 'vuex'

export default {
    name: 'ChannelBanner',
    data () {
        return {
        }
    },
    props: ['banner'],
    computed: {
        ...mapState(['lang'])
    },
    created () {
        this.banner.length < 2 && (this.swiperOptions = {})
    },
    mounted () {
        this.banner.length > 1 && new Swiper('.swiper-container', {
            loop: true,
            autoplay: {
                delay: 4000,
                stopOnLastSlide: false,
                disableOnInteraction: false
            },
            pagination: {
                el: '.swiper-pagination'
            }
        })
    },
    methods: {
        imgLoad (e) {
            e.target.parentNode.style.background = 'none'
        },
        imgError (e) {
            e.target.src = require('../../assets/img/default_img31.jpg')
        },
        filterLink (data) {
            return Filters.link(data)
        },
        isHyperlinks (link) {
            return this.$Common.isHyperlinks(link)
        }
    }
}
</script>

<style lang="scss">
    .banner-wrapper {
        height: 33.333vw;
        overflow: hidden;
        .swiper-container {
            height: 100%;
            .swiper-slide {
                background: #f6f6f6;
                a {
                    display: block;
                }
            }
            .banner-title {
                color: #fff;
                font-size: 4.259vw;
                line-height: 1.4;
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 23.148vw;
                box-sizing: border-box;
                padding: 0 3.611vw 3.926vw;
                display: flex;
                align-items: flex-end;
                background: linear-gradient(rgba(1,1,1,0) 10%,rgba(1,1,1,0.2));
                span {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    word-wrap: break-word;
                }
            }
            .swiper-pagination {
                bottom: 0;
                line-height: 1;
                .swiper-pagination-bullet {
                    width: 3.704vw;
                    height: 3.704vw;
                    border-radius: 50%;
                    box-sizing: border-box;
                    background-color: transparent;
                    border: 0.37vw solid #fff;
                    transform: scale(0.5);
                    opacity: 1;
                    margin: 0;
                    &.swiper-pagination-bullet-active {
                        background-color: #fff;
                    }
                }
            }
        }
    }
</style>
